export const PAGINATION_TAKE = 8;
